import styled from 'styled-components';

const IconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export default IconWrapper;
